import { css } from 'styled-components';
import { HEIGHT_SELECT_INPUT } from './constants';
export const SelectInputWrapperExtraStyles = css`
  height: ${HEIGHT_SELECT_INPUT}px;
`;